import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import {
  RotateApiKeyMutation,
  RotateApiKeyMutationVariables,
} from '../../../shared/generated/graphql';

// Stub type to include end_ts until types are regenerated
type RotateApiKeyMutationVariablesWithEndTs = RotateApiKeyMutationVariables & {
  end_ts?: number | null;
};

const ROTATE_API_KEY = gql`
  mutation RotateAPIKey($id: String!, $end_ts: Float) {
    rotateAPIKeyDefinition(id: $id, end_ts: $end_ts) {
      api_key
    }
  }
`;

export const useRotateAPIKey = (
  options?: MutationHookOptions<
    RotateApiKeyMutation,
    RotateApiKeyMutationVariablesWithEndTs
  >,
) => {
  return useMutation<
    RotateApiKeyMutation,
    RotateApiKeyMutationVariablesWithEndTs
  >(ROTATE_API_KEY, {
    errorPolicy: 'all',
    ...options,
  });
};
